import React, { useEffect, useState } from "react";
import { Target, ChevronDown } from "lucide-react";
import { nexusMissions } from "../lib/api";

const TONE = { done: "text-emerald-300", blocked: "text-rose-300", working: "text-amber-300", retrying: "text-amber-300", queued: "text-cyan-300" };

export const MissionsStrip = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const load = () => nexusMissions().then((r) => setItems(r.items || [])).catch(() => {});
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);
  if (!items.length) return null;
  const live = items.filter((m) => !["done", "blocked"].includes(m.status)).length;
  return (
    <div className="px-3 md:px-4 pt-2" data-testid="nexus-missions">
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-2 text-[11px] nx-mono text-cyan-200/70" data-testid="nexus-missions-toggle">
        <Target className="w-3.5 h-3.5 text-[#00F0FF]" /> MISSIONS · {live} active
        <span className="truncate flex-1 text-left text-cyan-100/60">{items[0].text}</span>
        <span className={TONE[items[0].status] || "text-cyan-300"}>{items[0].status}</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-1.5 space-y-1 max-h-48 overflow-y-auto" data-testid="nexus-missions-list">
          {items.map((m) => (
            <div key={m.id} className="text-[11px] bg-[#0a1526] border border-[#00F0FF1a] rounded-lg px-2.5 py-1.5" data-testid={`nexus-mission-${m.id}`}>
              <div className="flex gap-2"><span className="text-cyan-50 flex-1 truncate">{m.text}</span><span className={TONE[m.status] || "text-cyan-300"}>{m.status} · {m.attempts}/6</span></div>
              {(m.result || m.log?.at(-1)?.note) && <p className="text-cyan-200/50 truncate">{m.result || m.log.at(-1).note}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
